















import { Component, Vue, Provide } from 'vue-property-decorator'

import { KIDSWANT_BUSSINESSID, PAGE_TITLE, PAGE_TITLE_SHOP, PAGE_TITLE_SCENIC, SHARE_MSG, ShopTypes } from './config'
import { toV } from '@/app/core/utils'
import { getPosition, uid, getRouterQuery, skey, setShareInfo, getSelectedCityId, getSelectterm } from '@utils/index'
// import { uid } from '@utils/index'
import { Cell } from 'vant'

import CommentModule from './components/commentModule/index.vue'
import ServiceModule from './components/serviceModule/index.vue'
import DescModule from './components/descModule/index.vue'
import CouponModule from './components/couponModule/index.vue'

import { getUserInfo } from './shop.service'

import { namespace } from 'vuex-class'
import { isApp, isTCQZMiniprogram, isMiniprogram } from '@/app/core/utils'
const shopHomeModule = namespace('shopHome')

// const PAGE_SIZE = 5
@Component({
  components: {
    [Cell.name]: Cell,
    ServiceModule,
    DescModule,
    CouponModule,
    CommentModule
  }
})
export default class Shop extends Vue {
  private businessId: any
  private cityId: any
  readonly Children: ShopTypes = ShopTypes.Children

  @shopHomeModule.State shopDetail!: any

  @shopHomeModule.State shopType!: ShopTypes

  @shopHomeModule.State shopYuer!: boolean

  @shopHomeModule.State serviceDetail!: any

  @shopHomeModule.State commentDetail!: any

  @shopHomeModule.Action getShopDetailAction!: (par: { businessId: string | number }) => Promise<any>

  @shopHomeModule.Action getServiceItemAction!: (par: { storeId: string | number }) => Promise<any>

  @shopHomeModule.Action getCommentAction!: (par: { businessId: string | number }) => Promise<any>

  @shopHomeModule.Action getCommentAction2!: (par: { objectId: string | number }) => Promise<any>

  @shopHomeModule.Action getCouponAction!: (par: { shopId: string | number }) => Promise<any>

  get showStoreName() {
    console.log(11111111, this.shopDetail)

    return this.shopDetail && this.shopDetail.storeName && this.shopDetail.storeName.slice(0, 80)
  }

  jumpToBCertificateP() {
    this.$newClickTracker({
      bizType: '127',
      pageLevelId: '121012999',
      clickId: '200008'
    })
    this.$router.push({
      name: 'shopLicence',
      query: this.$route.query
    })
  }

  async getService() {
    if (!this.shopDetail) {
      return
    }
    const par: any = {
      cityId: this.shopDetail.city,
      isSpec: 2, // 0:不返回定制商品、2:返回所有商品
      uid,
      skey
    }
    if (this.shopDetail.isself == 1 && this.shopYuer) {
      /* 育儿自营商家查询商家下的商品 */
      par.businessId = [this.businessId]
    } else {
      /* 非育儿自营商家查询门店下的商品 */
      par.storeId = [this.shopDetail && this.shopDetail.storeId]
    }
    this.getServiceItemAction(par).then(async () => {
      let skutype = ''
      if (this.serviceDetail.list && this.serviceDetail.list.length > 0) {
        for (const item of this.serviceDetail.list) {
          if (item.templateType2Id === 601 || item.templateType2Id === 602) {
            skutype = '门票'
          }
        }
      }
      let selectterm = await getSelectterm()

      this.$newViewTracker({
        bizType: '127',
        pageLevelId: '121012999',
        pageParam: {
          popid: this.$route.query.businessId,
          citycode: getSelectedCityId(),
          skutype,
          selectterm
        }
      })
    })
  }

  async getComment(pageIndex = 1) {
    if (this.shopYuer) {
      const par = {
        page: pageIndex,
        size: 2,
        businessId: this.businessId,
        type: 9,
        orderBy: 1,
        show_user: 1
      }
      this.getCommentAction(par)
    } else {
      // 成长加商户从另一个接口获取评论
      const par = {
        page: pageIndex,
        size: 2,
        objectId: this.businessId,
        type: 1,
        uid,
        skey
      }
      this.getCommentAction2(par)
    }
  }

  async getCoupon() {
    const par = {
      shopId: this.businessId,
      uid,
      skey
    }
    this.getCouponAction(par)
  }

  async setShare() {
    const { nickname = '' } =
      uid &&
      (await getUserInfo({
        uid,
        skey
      }))
    const shareInfo = {
      title: this.showStoreName,
      desc: nickname + SHARE_MSG
    }
    setShareInfo(shareInfo)
  }

  setPageTitle() {
    if (this.shopType == ShopTypes.Children) {
      // 店铺详情
      this.$setTitle(PAGE_TITLE_SHOP)
    } else if (this.shopType == ShopTypes.Ticket) {
      // 景区详情
      this.$setTitle(PAGE_TITLE_SCENIC)
    } else {
      // 门店详情
      this.$setTitle(PAGE_TITLE)
    }
  }

  async created() {
    const businessId = getRouterQuery(this.$route.query.businessId)
    this.businessId = businessId
    const po = await getPosition()
    this.cityId = po && po.cityId
    const par = {
      businessId: this.businessId,
      latitude: po ? po.lat : '',
      longitude: po && po.lng
    }
    await this.getShopDetailAction(par)
    this.getComment()
    this.getService()
    this.getCoupon()
    this.setShare()
    this.setPageTitle()
    const app = document.getElementById('app')
    if (app) {
      app.style.background = '#f5f5f5'
    }
  }

  /* 查看优惠券事件埋点参数 */
  @Provide()
  viewCouponTrackParams: any = {
    bizType: '127',
    pageLevelId: '121012999',
    clickId: '200005'
  }
  /* 查看商品事件埋点参数 */
  @Provide()
  viewCmmdTrackParams: any = {
    bizType: '127',
    pageLevelId: '121012999',
    clickId: '200006'
  }
  /* 全部评价事件埋点参数 */
  @Provide()
  allCommentTrackParams: any = {
    bizType: '127',
    pageLevelId: '121012999',
    clickId: '200007'
  }
  /* 头图点击事件埋点参数 */
  @Provide()
  headImgTrackParams: any = {
    bizType: '127',
    pageLevelId: '121012999',
    clickId: '200001'
  }
  /* 查看地址事件埋点参数 */
  @Provide()
  addressTrackParams: any = {
    bizType: '127',
    pageLevelId: '121012999',
    clickId: '200002'
  }
  /* 电话事件埋点参数 */
  @Provide()
  telTrackParams: any = {
    bizType: '127',
    pageLevelId: '121012999',
    clickId: '200003'
  }
}
